import { render, staticRenderFns } from "./Lending.vue?vue&type=template&id=360b51fa&scoped=true"
import script from "./Lending.vue?vue&type=script&lang=js"
export * from "./Lending.vue?vue&type=script&lang=js"
import style0 from "./Lending.vue?vue&type=style&index=0&id=360b51fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b51fa",
  null
  
)

export default component.exports